// extracted by mini-css-extract-plugin
export default {"globalHeader":"ProjectPage_globalHeader__z7Xx+","projectHeader":"ProjectPage_projectHeader__0jow1","projectSheetTabBar":"ProjectPage_projectSheetTabBar__PQQbu"};